<template>
    <div class="row social-media-app">

        <transition name="fade" mode="out-in">
            <keep-alive include="Configurations">
                <router-view></router-view>
            </keep-alive>
        </transition>

    </div>
</template>
<script>
import { TranslationHelper } from "../../../_Base/Utils";
import { mapActions, mapGetters } from 'vuex'
import SocialMedia from "../../../_Api/SocialMedia";

export default {
    data() {
            return {
                content: 'Social Media App',
                aspData: null
            }
        },
        created() {
            let glassItemData = this.$parent.$data.glassItemData;
            if ( process_env == "development" ) {
                glassItemData.isEditing = true;
            }
            this.updateServerData( glassItemData );
            this.updateTranslationHelper( new TranslationHelper( this.$parent.$data.initialTranslations ) );
            this.loadConfigurations();
        },
        computed: {
            ...mapGetters( [ "serverData", "translationHelper", "configurations" ] )
        },
        methods: {
            ...mapActions( [ "updateTranslationHelper", "updateServerData", "updateConfigurations", "updateConfigurationsLoaded" ] ),

            loadConfigurations() {
                SocialMedia.getConfigurations( this.serverData, this.configurationsLoaded );
            },
            configurationsLoaded( data ) {
                let configs = data;
                if ( !configs.availableRooms ) {
                    configs.availableRooms = [];
                }
                if ( !configs.availableRoomFilters ) {
                    configs.availableRoomFilters = {
                        "connections": [],
                        "groups": [],
                        "sources": [],
                        "themes": [],
                        "stories": []
                    };
                }
                if ( !configs.selectedBroadcastFilters ) {
                    configs.selectedBroadcastFilters = {
                        "roomId": 0,
                        "connectionIds": [],
                        "groupIds": [],
                        "sources": [],
                        "themeIds": [],
                        "storyIds": [],
                        "skip": 0,
                        "take": 24,
                        "layout": "Posts"
                    };
                }
                if ( configs.availableRooms.length > 0 && configs.selectedBroadcastFilters.roomId === 0 ) {
                    configs.selectedBroadcastFilters.roomId = configs.availableRooms[ 0 ].id;
                }
                if ( configs.selectedBroadcastFilters.roomId !== 0 ) {
                    this.updateConfigurations( configs );
                    this.updateConfigurationsLoaded( false );
                    this.loadRoomFilters( configs.selectedBroadcastFilters.roomId )
                }
            },
            loadRoomFilters( roomId ) {
                SocialMedia.getRoom( roomId, ( data ) => {
                    this.configurations.availableRoomFilters = data;
                    this.updateConfigurations( this.configurations );
                    this.updateConfigurationsLoaded( true );
                } );
            }

        }

}
</script>


<style>
</style>
